import {useCallback, useMemo, useState} from 'react'
import useOcapiSite from './useOcapiSite'
import useMultiSite from './use-multi-site'
import {useCommerceData} from './use-commerce-data'
import {trackAddProductSetToCart, trackAddToCart} from '../tracking/analytics'
import {isProductSet} from '../utils/product-utils'

export {default as RedirectLinkPartnerModal} from '../components/redirect-link-partner-modal'

export const useRedirectLinkPartnerModal = ({product, onClick} = {}) => {
    const {isEcommerceEnabled} = useCommerceData(product)
    const [isOpen, setIsOpen] = useState(false)
    const onOpen = useCallback(() => setIsOpen(true), [])
    const onClose = useCallback(() => setIsOpen(false), [])

    const {
        locale: {id: locale, preferredCurrency}
    } = useMultiSite()
    const onClickWithTracking = useCallback(() => {
        if (isProductSet(product)) {
            trackAddProductSetToCart(
                product,
                // basket is not available, because content site
                null,
                null,
                locale,
                preferredCurrency
            )
        } else {
            trackAddToCart(
                product,
                // basket is not available because this is used within content site
                null,
                null,
                preferredCurrency
            )
        }
        onClick?.()
    }, [product, locale, onClick, preferredCurrency])
    const {redirectLinkPartnerAllProducts} = useOcapiSite()
    const rawRedirectValue = useMemo(
        () =>
            redirectLinkPartnerAllProducts &&
            JSON.parse(redirectLinkPartnerAllProducts)?.[locale.replace('-', '_')],
        [redirectLinkPartnerAllProducts, locale]
    )

    const redirectToPartner =
        typeof rawRedirectValue === 'object' ? rawRedirectValue?.link : rawRedirectValue
    const partnerBrandButtonColor =
        typeof rawRedirectValue === 'object' ? rawRedirectValue?.color : null
    const partnerBrand =
        typeof rawRedirectValue === 'object' ? rawRedirectValue?.partnerBrand : null
    const overlayAssetId =
        typeof rawRedirectValue === 'object' ? rawRedirectValue?.overlayAssetId : null

    const redirectLinkPartner = product?.c_redirectLinkPartner
    const partnerLink = redirectLinkPartner || redirectToPartner

    // partner redirect must only exist on non-ecommerce/content-only sites
    const isPartnerRedirectAvailable = !isEcommerceEnabled && !!partnerLink

    const hasOverlay = !!(redirectToPartner && partnerBrand && overlayAssetId)

    return {
        onOpen: hasOverlay ? onOpen : null,
        isAvailable: isPartnerRedirectAvailable,
        partnerLink,
        partnerBrandButtonColor,
        isOpen,
        onClose,
        overlayAssetId,
        partnerBrand,
        href: partnerLink,
        onClick: onClickWithTracking
    }
}
